// components/skeletons/WorkerProfileCardSkeleton.tsx
export function WorkerProfileCardSkeleton() {
  return (
    <div className="flex flex-col w-full gap-4 bg-white justify-between p-3 rounded-2xl animate-pulse">
      
      {/* Avatar + Name */}
      <div className="flex md:flex-row gap-4">
        <div className="h-[90px] w-[90px] bg-gray-200 rounded-lg"></div>

        <div className="flex flex-col gap-2 flex-1">
          <div className="h-4 w-32 bg-gray-200 rounded"></div>
          <div className="h-3 w-24 bg-gray-200 rounded"></div>
        </div>
      </div>

      {/* Info Row */}
      <div className="flex items-center gap-3">
        <div className="h-3 w-20 bg-gray-200 rounded"></div>
        <div className="h-3 w-16 bg-gray-200 rounded"></div>
        <div className="h-3 w-20 bg-gray-200 rounded"></div>
      </div>

      {/* Services */}
      <div>
        <div className="h-4 w-28 bg-gray-200 rounded mb-2"></div>
        <div className="flex gap-2">
          <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-6 w-16 bg-gray-200 rounded-full"></div>
          <div className="h-6 w-10 bg-gray-200 rounded-full"></div>
        </div>
      </div>

      {/* Description */}
      <div className="flex flex-col gap-2">
        <div className="h-4 w-24 bg-gray-200 rounded"></div>
        <div className="h-3 w-full bg-gray-200 rounded"></div>
        <div className="h-3 w-full bg-gray-200 rounded"></div>
        <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
      </div>

      {/* Buttons */}
      <div className="flex gap-2 mt-2">
        <div className="h-8 w-full bg-gray-200 rounded-3xl"></div>
        <div className="h-8 w-full bg-gray-200 rounded-3xl"></div>
      </div>

    </div>
  );
}
